"use strict";

var PropTypes = require('prop-types');

var compose = require('../hoc/compose');

var template = require('./panelHeaderIllustration.jsx');

var PanelHeaderIllustration = template;
PanelHeaderIllustration.displayName = 'PanelHeaderIllustration';
PanelHeaderIllustration.propTypes = {
  blueStripHeight: PropTypes.number
};
PanelHeaderIllustration.defaultProps = {
  blueStripHeight: 90
};
module.exports = compose(PanelHeaderIllustration);